import React from "react";
import {Component} from "react";
import { slide as Burger } from 'react-burger-menu'
import styled from "styled-components";
import ReactDOM from 'react-dom';
import Link from "gatsby-link";


var BurgerStyles = {
    bmBurgerButton: {
      position: 'fixed',
      width: '36px',
      height: '30px',
      left: 'initial',
      right: '36px',
      top: '70px',
    },
    bmBurgerBars: {
      background: 'white'
    },
    bmCrossButton: {
      height: '24px',
      width: '24px'
    },
    bmCross: {
      background: '#bdc3c7'
    },
    bmMenu: {
      background: '#373a47',
      padding: '2.5em 1.5em 0',
      fontSize: '1.15em'
    },
    bmMorphShape: {
      fill: '#373a47'
    },
    bmItemList: {
      color: '#b8b7ad',
      padding: '0.8em'
    },
    bmOverlay: {
      background: 'rgba(0, 0, 0, 0.3)'
    }
  }
  
const BurgerItem = styled.div`
    text-decoration: none;
    color: #b8b7ad;

    &:hover,
    &:focus {
        color: #c94e50;

    }
    
`

var ResponsiveWrap = styled.div`
    @media screen and (min-width: 900px) {
        display: none;
    }
`

class MenuWrap extends Component {
    constructor (props) {
      super(props);
      this.state = {
        hidden: false
      };
    }
  
  
    show() {
      this.setState({hidden : false});
    }

    hide() {
        this.setState({hidden: true})
    }
  
    render() {
      let style;
  
      if (this.state.hidden) {
        style = {display: 'none'};
      }
  
      return (
        <div style={style}>
          {this.props.children}
        </div>
      );
    }
  }

  export default () => (
    <ResponsiveWrap>
        <MenuWrap >
            <Burger pageWrapId={ "page-wrap" } styles = { BurgerStyles } right>
                        <Link style={{textDecoration:"none"}} to="/#menu"><BurgerItem  className="menu-item" >Menü</BurgerItem></Link>
                        <Link style={{textDecoration:"none"}} to="/contact"><BurgerItem className="menu-item">Reservieren</BurgerItem></Link>
                        <Link style={{textDecoration:"none"}} to="/#anfahrt"><BurgerItem  className="menu-item">Anfahrt</BurgerItem></Link>
                        <Link style={{textDecoration:"none"}} to="/impressung"><BurgerItem  className="menu-item">Impressung</BurgerItem></Link>
            </Burger>
        </MenuWrap>
    </ResponsiveWrap>
  )


// WEBPACK FOOTER //
// ./src/components/burger.js